import PushNotifications from "./settings/PushNotifications";
import Totp from "./settings/Totp";
import Extensions from "./settings/Extensions";

function ProfileSettings() {

	return (
		<div className={"m-2 border p-3 bg-white shadow-sm"}>
			<Totp />
			<hr />
			<PushNotifications />
			<hr />
			<Extensions />
		</div>
	);
}

export default ProfileSettings;